import { z } from "zod";

export const ClienteSimplificadoSchema = z.object({
    nomeCliente: z.coerce.string().nonempty("Nome do cliente é obrigatório."),
    cpf: z.coerce.string().nullable().default(null),
    dataNascimento: z.coerce.date({ invalid_type_error: "Data de nascimento inválida." }).nullable().default(null),
    observacao: z.coerce.string().nullable().default(null),

    cnpj: z.coerce.string().nullable().default(null),
    razaoSocial: z.coerce.string().nullable().default(null),


});

export type ClienteSimplificadoForm = z.infer<typeof ClienteSimplificadoSchema>;

export const defaultClienteSimplificadoForm: Partial<ClienteSimplificadoForm> = {
    cpf: null,
    observacao: null,
    cnpj: null,
    razaoSocial: null,

}